/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_F2_DescInputs */

const en_landing_features_f2_desc = /** @type {(inputs: Landing_Features_F2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram built its name on text inside images. Put the exact words in quotes and the model sets them as a designer would, on posters, labels, signs and packaging, at native 2K. Edit the wording later and the style, size and position stay put.`)
};

const zh_landing_features_f2_desc = /** @type {(inputs: Landing_Features_F2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 以图中文字闻名。把确切文字放进引号，Ideogram 4.5 会像设计师一样排版，海报、标签、招牌、包装都能胜任，原生 2K。之后修改文案，字体风格、大小与位置依旧保持。`)
};

/**
* | output |
* | --- |
* | "Ideogram built its name on text inside images. Put the exact words in quotes and the model sets them as a designer would, on posters, labels, signs and packa..." |
*
* @param {Landing_Features_F2_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_f2_desc = /** @type {((inputs?: Landing_Features_F2_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_F2_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_f2_desc(inputs)
	return zh_landing_features_f2_desc(inputs)
});
export { landing_features_f2_desc as "landing.features.f2_desc" }